import React from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'

import { hover } from 'styles/colors'
import { title } from 'styles/texts'

const Item = styled.div`
  ${title};
  cursor: pointer;
  padding: 18px 30px;
  ${props => (props.active ? 'background-color: ' + hover : '')};

  &:hover {
    background-color: ${hover};
  }
`

const MoreMenuItem = ({ link, onClick, text, active, history }) => (
  <Item onMouseDown={onClick || (() => history.push(link))} active={active}>
    {text}
  </Item>
)

export default withRouter(MoreMenuItem)



// WEBPACK FOOTER //
// ./src/components/Header/MoreMenu/MoreMenuItem.js